module.exports = __webpack_public_path__ + "img/step2.e09caead.png";